import Cookies from 'js-cookie';
import { sendMessageUp } from '@helpers/iframeMessages';
import { logError } from '@providers/ErrorTracking';
import isBrowser from '@helpers/isBrowser';
import { JWT_COOKIE_NAME } from '@configuration/client';
import { AuthUser } from './constants';
import decodeToken from './decodeToken';

function getCookieUser(): AuthUser | null {
  const jwtCookie = Cookies.get(JWT_COOKIE_NAME);
  try {
    if (jwtCookie) {
      return decodeToken(jwtCookie);
    }
  } catch (error) {
    logError(error);
  }
  if (!isBrowser()) {
    return null;
  }

  sendMessageUp({
    message: 'get-client-cookie',
  });

  return null;
}

export default getCookieUser;
